import React, { useEffect, useRef } from 'react';
import { Input, Button, Form } from 'antd';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { usePersistedStore } from '../../store/persisted-store';
import { LeftOutlined } from "@ant-design/icons";
import AuthLayout from './AuthLayout';

export default function Password() {
  const navigate = useNavigate();
  const location = useLocation();
  const [form] = Form.useForm();
  const passwordInputRef = useRef(null);

  const { login, authentication, auth, clearLoginInfo, clearAuthMessage, getUserInfo, getUserBusinessesAc } = usePersistedStore();

  const loading = auth.loading;
  const message = auth.message;
  const mobileNumber = auth.mobile;
  const tokenPassword = auth.tokenPassword;
  const returnUrl = auth.returnUrl;

  useEffect(() => {
    if (!mobileNumber) {
      navigate('/auth/login' + location.search);
    }
  }, [mobileNumber, navigate, location.search]);

  useEffect(() => {
    if (passwordInputRef.current) {
      passwordInputRef.current.focus();
    }
  }, []);

  const handleReturnUrl = () => {
    const searchParams = new URLSearchParams(location.search);
    const returnUrlParam = searchParams.get('returnUrl') || returnUrl;

    if (returnUrlParam && returnUrlParam !== '/' && returnUrlParam !== '/auth') {
      navigate(returnUrlParam);
    } else {
      navigate('/dashboard');
    }
  };

  async function onFinish(values) {
    try {
      const result = await login({
        Password: values.password,
        tokenPassword
      });

      if (result) {
        // Get user info after successful login
        const userInfo = await getUserInfo();
        if (userInfo?.BusinessToken) {
          await getUserBusinessesAc();
          handleReturnUrl();
        }
      }
    } catch (error) {
      console.error('Login error:', error);
    }
  }

  function onFinishFailed(errorInfo) {
    form.scrollToField(errorInfo.errorFields[0].name, {
      scroll: {
        offsetTop: 65,
      },
    });
  }

  return (
    <AuthLayout title="ورود" subtitle={`رمز عبور شماره ${mobileNumber} را وارد کنید`}>
      <div
        onClick={() => {
          clearLoginInfo();
          navigate('/auth/login' + location.search);
        }}
        className="mb-3 text-primary"
        style={{ cursor: 'pointer' }}
      >
        اصلاح نام کاربری
      </div>

      <Form
        name="password"
        layout="vertical"
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <div className="form-group">
          <Form.Item
            name="password"
            label="رمز عبور خود را وارد کنید"
            validateStatus={message ? 'error' : 'validating'}
            help={message || ""}
            className="input-pass"
            rules={[{ required: true, message: "رمز عبور اجباری است" }]}
          >
            <Input.Password
              placeholder="رمز عبور خود را وارد کنید"
              className="form-control form-input"
              ref={passwordInputRef}
              onChange={() => message && clearAuthMessage()}
            />
          </Form.Item>
        </div>

        <div className="mt-3">
          <Button
            type="primary"
            className="btn pass-button waves-effect waves-light"
            block
            loading={loading}
            htmlType="submit"
          >
            ورود
          </Button>
        </div>
      </Form>

      <div className="mt-3 text-center">
        <Button
          type="link"
          onClick={() => {
            clearAuthMessage();
            authentication({ MobileNumber: mobileNumber })
              .then(() => {
                navigate('/auth/code' + location.search);
              });
          }}
          className="text-primary"
        >
          ورود با رمز یکبار مصرف
          <LeftOutlined className="ms-1" />
        </Button>
      </div>
    </AuthLayout>
  );
}
